import React from 'react';
import Button from '@shape-construction/arch-ui/src/Button';
import Spinner from '@shape-construction/arch-ui/src/Spinner';
import { useTranslation } from 'react-i18next';

interface LoadMoreButtonProps {
  isLoading?: boolean;
  onClick: () => void;
  buttonType: string;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ isLoading, onClick, buttonType }) => {
  const { t } = useTranslation();

  return (
    <div className="my-4 flex justify-center">
      {isLoading ? (
        <Button color="secondary" variant="outlined" size="md" aria-label="loading" leadingIcon={Spinner}>
          {t('loadMoreButton.loading')}
        </Button>
      ) : (
        <Button color="secondary" variant="outlined" size="md" aria-label={`load-more-${buttonType}`} onClick={onClick}>
          {t('loadMoreButton.loadMore', { buttonType })}
        </Button>
      )}
    </div>
  );
};
